class Status {
    conversationId;
    interval;

    start(conversationId) {
        this.conversationId = conversationId;
    }

    clear() {
        this.conversationId = null;
    }
}

export const status = Status;